export const projectionStatus = {
	NO_PROJECTIONS: 'No Projections',
	NOTIFICATION_FAILED: 'Notification Failed',
	NOTIFICATION_PENDING: 'Notification Pending',
	NOTIFICATION_SENT: 'Notification Sent',
	PROJECTIONS_SENT: 'Projections Sent'
};
